import withKpiCards from './withKpiCards';
import withPurchaseOrdersDropzone from './withPurchaseOrdersDropzone';
import withValidationOrdersDropzone from './withValidationOrdersDropzone';

const extensions = {
  kpiCards: withKpiCards,
  purchaseOrdersDropzone: withPurchaseOrdersDropzone,
  validationOrdersDropzone: withValidationOrdersDropzone,
};

export default extensions;
